import React, { useState } from 'react';
import axios from 'axios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';

function App() {

	const apiKey = 'erpTrucoo';
    const [employeeData, setEmployeeData] = useState('');

    const newData = (e) => {
        const { name, value } = e.target;
        setEmployeeData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
    };

    const addEmployee = async (e) => {
		e.preventDefault();
		try {
			const response = await axios.post('https://api.trucoo.in/employees/add-employee/', employeeData, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': apiKey
				}
			});

			console.log(response.data);

			if(response.data.status === 'success'){
				setEmployeeData({});
				window.location = '/view-employee';
			}

		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
				<div class="box box-body">
					<form onSubmit={addEmployee}>
					<div class="row">
                       
						<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-12">
                            <div class="box">
							    <div class="box-body">

								    <h4 class="box-title text-primary mb-0"><i class="ti-user me-15"></i> Personal Info</h4>
								    <hr class="my-15" />

								    <div class="row">
								        <div class="col-md-12">
									        <div class="form-group">
									            <label class="form-label">Full Name</label>
									            <input type="text" class="form-control" name="name" value={employeeData.name} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
								    </div>
								    <div class="row">
								        <div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">E-mail</label>
									            <input type="email" class="form-control" name="email" value={employeeData.email} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
								        <div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Contact Number</label>
									            <input type="text" class="form-control" name="phone" value={employeeData.phone} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
								    </div>
                                    <div class="form-group">
								        <label class="form-label">Address</label>
								        <textarea rows="5" class="form-control" name="address" value={employeeData.address} onChange={(e)=>newData(e)} required></textarea>
								    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-12">
                            <div class="box">
                                <div class="box-body">
								    <h4 class="box-title text-primary mb-0"><i class="ti-save me-15"></i>Professional Info</h4>
								    <hr class="my-15" />
                                    <div class="row">
								        <div class="col-md-4">
									        <div class="form-group">
									            <label class="form-label">Employee ID</label>
									            <input type="text" class="form-control" name="eId" value={employeeData.eId} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
								        <div class="col-md-4">
									        <div class="form-group">
                                            <label class="form-label">Position</label>
									            <select class="form-select" name="position" value={employeeData.position} onChange={(e)=>newData(e)} required >
										            <option value="" hidden>Select a role</option>
										            <option>Manager</option>
										            <option>Admin</option>
										            <option>HR</option>
										            <option>Marketing Manager</option>
										            <option>Sales Executive</option>
										            <option>Driver</option>
										            <option>Other Staff</option>
									            </select>
									        </div>
								        </div>
										<div class="col-md-4">
									        <div class="form-group">
                                            <label class="form-label">Access</label>
									            <select class="form-select" name="access" value={employeeData.access} onChange={(e)=>newData(e)} required >
										            <option value="" hidden>Select a role</option>
										            <option value="admin1">Admin - 1</option>
										            <option value="admin2">Admin - 2</option>
										            <option value="gm">GM</option>
										            <option value="md">MD</option>
										            <option value="office">Office</option>
										            <option value="account">Accounts</option>
										            <option value="sales">Marketing</option>
									            </select>
									        </div>
								        </div>
								    </div>
								    <div class="row">
								        <div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Company E-mail</label>
									            <input type="text" class="form-control" name="cEmail" value={employeeData.cEmail} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
								        <div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Password</label>
									            <input type="text" class="form-control" name="password" value={employeeData.password} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
								    </div>
								    <div class="form-group">
								        <label class="form-label">About Position</label>
								        <textarea rows="5" class="form-control" name="about" value={employeeData.about} onChange={(e)=>newData(e)}></textarea>
								    </div>
							    </div>
							</div>
						</div>


                        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="box">
                                <div class="box-body">
							        <div class="box-footer" align="center">
								        <button type="button" class="btn btn-primary-light me-1"><i class="ti-trash"></i> Cancel</button>
								        <button type="submit" class="btn btn-primary"><i class="ti-save-alt"></i> Save</button>
							        </div>  
						
					            </div>
						    </div>
						</div>
                     
					</div>
					</form>
				</div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default App;